import React, { useEffect, useState } from "react";
import imageCompression from "browser-image-compression";
import { LazyImageComponent } from "../../CustomComponent/lazy_loading_image";

export default function PolyhouseCenterNew({ length, width, BASE_SCALE }) {
  const [result, setResult] = useState(null);
  const leftUrl =
    "https://res.cloudinary.com/dsmabnook/image/upload/v1758522463/left-nvph-new-01_1_bncptw.png";
  const rightUrl =
    "https://res.cloudinary.com/dsmabnook/image/upload/v1758526682/right-nvph-new-01_1_nwy4jd.png";
  const centerUrl =
    "https://res.cloudinary.com/dsmabnook/image/upload/v1758522463/center-nvph-new-01_1_fk0t9k.png";
  const logoUrl =
    "https://res.cloudinary.com/dsmabnook/image/upload/v1758885255/kryzen_logo_2_5_t5jwwe.png";

  // const generateImage = async (count) => {
  //   const loadImage = (src) =>
  //     new Promise((resolve, reject) => {
  //       const img = new Image();
  //       img.crossOrigin = "anonymous"; // avoid CORS issues
  //       img.onload = () => resolve(img);
  //       img.onerror = reject;
  //       img.src = src;
  //     });

  //   try {
  //     const [left, right, center, logo] = await Promise.all([
  //       loadImage(leftUrl),
  //       loadImage(rightUrl),
  //       loadImage(centerUrl),
  //       loadImage(logoUrl), // 🔹 load logo too
  //     ]);

  //     // calculate final width
  //     const width = left.width + right.width + center.width * count;
  //     const height = Math.max(left.height, right.height, center.height);

  //     const canvas = document.createElement("canvas");
  //     canvas.width = width;
  //     canvas.height = height;
  //     const ctx = canvas.getContext("2d");

  //     // draw left
  //     ctx.drawImage(left, 0, 0);

  //     // draw centers
  //     for (let i = 0; i < count; i++) {
  //       ctx.drawImage(center, left.width + i * center.width, 0);
  //     }

  //     // draw right
  //     ctx.drawImage(right, left.width + count * center.width, 0);

  //     // 🔹 add watermark (repeated logo)
  //     const watermarkScale = 3; // 20% of original logo size
  //     const wmWidth = logo.width * watermarkScale;
  //     const wmHeight = logo.height * watermarkScale;

  //     const xSpacing = 150; // space between watermarks horizontally
  //     const ySpacing = 150; // space between watermarks vertically
  //     ctx.globalAlpha = 0.15; // make watermark transparent

  //     // for (let y = 0; y < height; y += wmHeight + ySpacing) {
  //     //   for (let x = 0; x < width; x += wmWidth + xSpacing) {
  //     //     ctx.drawImage(logo, x, y, wmWidth, wmHeight);
  //     //   }
  //     // }

  //     const angle = (-30 * Math.PI) / 180; // rotate -30 degrees
  //     for (let y = 0; y < height; y += wmHeight + ySpacing) {
  //       for (let x = 0; x < width; x += wmWidth + xSpacing) {
  //         ctx.save(); // save current state
  //         ctx.translate(x + wmWidth / 2, y + wmHeight / 2); // move origin to center of logo
  //         ctx.rotate(angle); // rotate canvas
  //         ctx.drawImage(logo, -wmWidth / 2, -wmHeight / 2, wmWidth, wmHeight); // draw centered
  //         ctx.restore(); // restore original state
  //       }
  //     }

  //     ctx.globalAlpha = 1.0; // reset opacity

  //     // export result
  //     const dataUrl = canvas.toDataURL("image/png");
  //     setResult(dataUrl);
  //   } catch (err) {
  //     console.error("Error generating image", err);
  //   }
  // };

  const generateImage = async (count) => {
    const loadImage = (src) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });

    try {
      const [left, right, center, logo] = await Promise.all([
        loadImage(leftUrl),
        loadImage(rightUrl),
        loadImage(centerUrl),
        loadImage(logoUrl),
      ]);

      // calculate raw final width and height
      let width = left.width + right.width + center.width * count;
      let height = Math.max(left.height, right.height, center.height);

      // 🔹 SCALE LOGIC: ensure canvas width stays below browser limit
      const MAX_CANVAS_WIDTH = 16000;
      const scale = width > MAX_CANVAS_WIDTH ? MAX_CANVAS_WIDTH / width : 1;

      width = width * scale;
      height = height * scale;

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");

      // draw left image scaled
      ctx.drawImage(left, 0, 0, left.width * scale, left.height * scale);

      // draw center images scaled
      for (let i = 0; i < count; i++) {
        ctx.drawImage(
          center,
          (left.width + i * center.width) * scale,
          0,
          center.width * scale,
          center.height * scale
        );
      }

      // draw right image scaled
      ctx.drawImage(
        right,
        (left.width + count * center.width) * scale,
        0,
        right.width * scale,
        right.height * scale
      );

      // 🔹 add watermark (scaled)
      const watermarkScale = 3 * scale; // scale watermark with canvas
      const wmWidth = logo.width * watermarkScale;
      const wmHeight = logo.height * watermarkScale;
      const xSpacing = 150 * scale; // spacing also scaled
      const ySpacing = 150 * scale;
      const angle = (-30 * Math.PI) / 180;

      ctx.globalAlpha = 0.15; // watermark transparency

      for (let y = 0; y < height; y += wmHeight + ySpacing) {
        for (let x = 0; x < width; x += wmWidth + xSpacing) {
          ctx.save();
          ctx.translate(x + wmWidth / 2, y + wmHeight / 2);
          ctx.rotate(angle);
          ctx.drawImage(logo, -wmWidth / 2, -wmHeight / 2, wmWidth, wmHeight);
          ctx.restore();
        }
      }

      ctx.globalAlpha = 1.0; // reset transparency
      const dataUrl = canvas.toDataURL("image/png");
      setResult(dataUrl);
    } catch (err) {
      console.error("Error generating image", err);
    }
  };

  useEffect(() => {
    if (width) {
      if (width <= 12) {
        setResult(
          "https://res.cloudinary.com/dsmabnook/image/upload/v1757742739/12M-01_zw7hum.png"
        );
      }
      let avlWidth = width - 4;
      let avlLength = length - 4;
      let lCount = avlLength / 4;
      let count = (avlWidth - 16) / 8;
      generateImage(count);
    }
  }, [width]);
  // const downloadImage = () => {
  //   if (!result) return;

  //   const link = document.createElement("a");
  //   link.href = result; // dataURL from canvas
  //   link.download = "polyhouse-center-view.png"; // file name
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const downloadImage = async () => {
    if (!result) return;

    const img = new Image();
    img.src = result;
    await img.decode(); // wait for image to load

    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    canvas.getContext("2d").drawImage(img, 0, 0);

    canvas.toBlob(async (blob) => {
      const compressedBlob = await imageCompression(blob, {
        maxSizeMB: 1, // target size
        maxWidthOrHeight: 2000,
        useWebWorker: true,
      });

      const url = URL.createObjectURL(compressedBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "polyhouse-center-view.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, "image/png");
  };

  return (
    <div className="p-4">
      {/* <h3>Polyhouse - center view (No big column)</h3> */}
      {result && (
        <>
          {/* <img
            src={result}
            id="svgImageCenter"
            alt="Generated Polyhouse"
            className="p-4"
            style={{ maxWidth: "100%" }}
          /> */}

          <LazyImageComponent
            id="svgImageCenter"
            width="100%"
            src={result}
            alt="Generated Polyhouse"
          />

          {/* <button
            onClick={downloadImage}
            className="btn btn-primary btn-sm m-2"
          >
            Download
          </button>{" "} */}
        </>
      )}
    </div>
  );
}
